import { initReactI18next } from 'react-i18next';

import type { LocalizationProviderProps } from '@mui/x-date-pickers';
import { enUS, ptBR } from '@mui/x-date-pickers/locales';
import i18n from 'i18next';

import serverTranslationEn from '@features/i18n/en-US/serverTranslation.json';
import uiTranslationEn from '@features/i18n/en-US/uiTranslation.json';
import serverTranslationPtBr from '@features/i18n/pt-BR/serverTranslation.json';
import uiTranslationPtBr from '@features/i18n/pt-BR/uiTranslation.json';

import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';

enum LOCALE {
  EN_US = 'en-US',
  PT_BR = 'pt-BR',
}

export const defaultNS = 'uiTranslation';

export const resources: Record<
  LOCALE,
  {
    uiTranslation: Record<string, string>;
    serverTranslation: Record<string, string>;
  }
> = {
  [LOCALE.EN_US]: {
    uiTranslation: uiTranslationEn,
    serverTranslation: serverTranslationEn,
  },
  [LOCALE.PT_BR]: {
    uiTranslation: uiTranslationPtBr,
    serverTranslation: serverTranslationPtBr,
  },
};

const getLocaleFromQuery = (): LOCALE => {
  const parameters = new URLSearchParams(window.location.search);
  const language = parameters.get('language') as LOCALE;

  return Object.values(LOCALE).includes(language) ? language : LOCALE.EN_US;
};

export const getAdapterLocale = () => {
  const locales: Record<
    LOCALE,
    NonNullable<LocalizationProviderProps<string>['adapterLocale']>
  > = {
    [LOCALE.EN_US]: 'en',
    [LOCALE.PT_BR]: 'pt-br',
  };

  return locales[getLocaleFromQuery()] || locales[LOCALE.EN_US];
};

export const getLocaleText = () => {
  const localeTexts: Record<
    LOCALE,
    NonNullable<LocalizationProviderProps<string>['localeText']>
  > = {
    [LOCALE.PT_BR]:
      ptBR.components.MuiLocalizationProvider.defaultProps.localeText,
    [LOCALE.EN_US]:
      enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  };

  return localeTexts[getLocaleFromQuery()] || localeTexts[LOCALE.EN_US];
};

i18n.use(initReactI18next).init(
  {
    resources,
    defaultNS,
    lng: getLocaleFromQuery(),
    ns: ['uiTranslation', 'serverTranslation'],
    interpolation: {
      escapeValue: false,
    },
  },
  () => {
    const formatter = i18n.services.formatter;

    formatter?.add('uppercase', (value) => String(value).toUpperCase());
    formatter?.add('lowercase', (value) => String(value).toLowerCase());
  }
);

export const adapterLocale = getAdapterLocale();
export const localeText = getLocaleText();

export { default } from 'i18next';
